var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.202,
    height: 16.841,
    viewBox: "0 0 17.202 16.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_114",
    "data-name": "Layer 114",
    transform: "translate(-3 -2.974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14870",
    "data-name": "Path 14870",
    d: "M20.2,11.4a8.441,8.441,0,0,1-6.546,8.171A8.673,8.673,0,0,1,3.975,15.3,8.266,8.266,0,0,1,5.926,5.1a8.76,8.76,0,0,1,10.606-.57l-.105-.3a.953.953,0,0,1,.626-1.209.986.986,0,0,1,1.238.611l.956,2.8a.916.916,0,0,1-.134.84.964.964,0,0,1-.822.392H15.423a.922.922,0,0,1-.277-1.811A6.811,6.811,0,0,0,7,6.655a6.424,6.424,0,0,0-1.248,7.907,6.752,6.752,0,0,0,7.524,3.161A6.564,6.564,0,0,0,18.29,11.4a.956.956,0,0,1,1.911,0Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f12f7e3b.svg";
export { ForwardRef as ReactComponent };